(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pip-meter-sticky-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pip-meter-sticky-cart')) {
    customElements.define('pip-meter-sticky-cart', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.price = this.querySelector('[data-pip-sticky-price]');
        this.section = this.closest('.shopify-section');
        this.onUpdate = () => this.sync();
        this.onScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); });
        };
        this.onClick = () => {
          this.sync();
          if (!this.button.disabled && this.mainButton && !this.mainButton.disabled) this.mainButton.click();
        };
        this.button.addEventListener('click', this.onClick);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);
        this.sectionObserver = new MutationObserver(() => this.bind());
        this.sectionObserver.observe(this.section, { childList: true, subtree: true });
        this.bodyObserver = new MutationObserver(this.onUpdate);
        this.bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
        this.bind();
      }
      bind() {
        const root = this.section.querySelector('pip-refill-preview');
        const button = root?.querySelector('.pip-refill-preview__button');
        const price = root?.querySelector('[data-price]');
        if (button === this.mainButton && price === this.mainPrice) return;
        this.mainButton = button;
        this.mainPrice = price;
        this.stateObserver?.disconnect();
        if (root && button && price) {
          this.stateObserver = new MutationObserver(this.onUpdate);
          this.stateObserver.observe(root, { attributes: true, attributeFilter: ['disabled'], childList: true, characterData: true, subtree: true });
        }
        this.sync();
      }
      sync() {
        const disabled = !this.mainButton || this.mainButton.disabled;
        if (this.button.disabled !== disabled) this.button.disabled = disabled;
        this.button.setAttribute('aria-disabled', String(disabled));
        const price = this.mainPrice?.textContent.trim() || '';
        if (this.price.textContent !== price) this.price.textContent = price;
        const rect = this.mainButton?.getBoundingClientRect();
        const footer = document.querySelector('.footer')?.getBoundingClientRect();
        const footerVisible = footer && footer.top < window.innerHeight && footer.bottom > 0;
        const overlayOpen = document.body.classList.contains('no-scroll') || document.body.classList.contains('rebuy-cart-visible');
        const show = Boolean(rect && rect.bottom < 0 && rect.width > 0 && rect.height > 0 && !footerVisible && !overlayOpen);
        this.hidden = !show;
        const height = show && !window.matchMedia('(min-width: 990px)').matches ? this.getBoundingClientRect().height : 0;
        document.documentElement.style.setProperty('--pip-mobile-bottom-obstruction', height + 'px');
      }
      disconnectedCallback() {
        this.sectionObserver?.disconnect();
        this.stateObserver?.disconnect();
        this.bodyObserver?.disconnect();
        this.mainButton = null;
        this.mainPrice = null;
        this.button?.removeEventListener('click', this.onClick);
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
        document.documentElement.style.setProperty('--pip-mobile-bottom-obstruction', '0px');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pip-refill-preview"] && !Shopify.designMode) return;
  try {
    function resolvePipMeterRefillSelection(input, config) {
    const kits = {
      small: { variantId: '41036642582613', sku: '940-50' },
      large: { variantId: '42128977100885', sku: '943-150' }
    };
    const sizes = {
      mighty: { label: 'Mighty Fine', variantId: '40960428310613', sku: '943R' },
      so: { label: 'So Fine', variantId: '40960428376149', sku: '944R' },
      fine: { label: 'Fine', variantId: '40960428441685', sku: '945R' }
    };
    if (!input || !config || config.contextReady !== true || config.currency !== 'USD' ||
        config.programKey !== 'pip-meter-refill-v1' || !Array.isArray(config.variants) ||
        !Object.hasOwn(kits, input.kit) || !['kit', 'refills'].includes(input.mode)) return null;
    const variant = target => {
      const matches = config.variants.filter(item => String(item.id) === target.variantId);
      const item = matches.length === 1 ? matches[0] : null;
      return item && item.sku === target.sku && item.available === true &&
        Number.isSafeInteger(item.price) && item.price > 0 ? item : null;
    };
    const kit = variant(kits[input.kit]);
    if (!kit) return null;
    const base = {
      mode: input.mode,
      previewPricing: { currency: 'USD', discountPercent: 0, initialRegularCents: kit.price, initialCents: kit.price },
      initialKit: { productId: '7061323808853', variantId: String(kit.id), sku: kit.sku, sellingPlanId: null, quantity: 1 },
      lineItemProperties: {}
    };
    if (input.mode === 'kit') return kit.requiresSellingPlan === true ? null : base;
    if (config.programEnabled !== true || !Object.hasOwn(sizes, input.size) ||
        !['1', '2', '3'].includes(input.frequency)) return null;
    const refill = variant(sizes[input.size]);
    if (!refill) return null;
    const allocated = (item, id) => {
      if (!Number.isSafeInteger(Number(id)) || Number(id) <= 0 || !Array.isArray(item.allocations)) return null;
      const matches = item.allocations.filter(allocation => String(allocation.id) === String(id));
      const allocation = matches.length === 1 ? matches[0] : null;
      const expected = Math.round(item.price * 0.9);
      return allocation && allocation.recurring === true && allocation.price === expected &&
        allocation.compareAtPrice === item.price && allocation.perDeliveryPrice === expected &&
        (allocation.checkoutCharge == null || allocation.checkoutCharge === expected) &&
        (allocation.remainingBalance == null || allocation.remainingBalance === 0) &&
        Array.isArray(allocation.adjustments) && allocation.adjustments.length <= 1 &&
        allocation.adjustments.every(adjustment => adjustment.price === expected) ? allocation : null;
    };
    const kitPlan = allocated(kit, config.kitPlans?.[input.frequency]);
    const refillPlan = allocated(refill, config.refillPlans?.[input.frequency]);
    if (!kitPlan || !refillPlan || String(kitPlan.id) === String(refillPlan.id)) return null;
    const frequencyLabel = input.frequency + (input.frequency === '1' ? ' month' : ' months');
    return {
      ...base,
      previewPricing: { ...base.previewPricing, discountPercent: 10, initialCents: kitPlan.price,
        refillRegularCents: refill.price, refillCents: refillPlan.price },
      initialKit: { ...base.initialKit, sellingPlanId: String(kitPlan.id) },
      lineItemProperties: { 'Refill lancet size': sizes[input.size].label,
        'Refill frequency': frequencyLabel, 'Pip refill program': config.programKey },
      futureRefill: { productId: '7060233355349', variantId: String(refill.id), sku: refill.sku,
        sellingPlanId: String(refillPlan.id), cadenceMonths: Number(input.frequency), quantity: 1 }
    };
  }
  function resolvePipMeterRefillGate(selection, config, cart) {
    if (!selection || !config || config.contextReady !== true) return 'unavailable';
    if (!cart) return 'checking';
    if (cart.currency !== 'USD' || !Number.isInteger(cart.item_count) || cart.item_count < 0 || !Array.isArray(cart.items)) return 'error';
    if (selection.mode === 'refills' && config.allowMultiKitTest !== true && cart.items.some(item =>
      ['41036642582613', '42128977100885'].includes(String(item.variant_id ?? item.id)) &&
      item.selling_plan_allocation)) return 'cart';
    return 'ready';
  }
  function buildPipMeterRefillCartPayload(selection, config) {
    if (!selection?.initialKit || !config) return null;
    const kit = { '41036642582613': 'small', '42128977100885': 'large' }[selection.initialKit.variantId];
    const size = { 'Mighty Fine': 'mighty', 'So Fine': 'so', 'Fine': 'fine' }[selection.lineItemProperties?.['Refill lancet size']];
    const verified = resolvePipMeterRefillSelection({
      kit, mode: selection.mode, size, frequency: String(selection.futureRefill?.cadenceMonths)
    }, config);
    if (!verified || verified.initialKit.variantId !== selection.initialKit.variantId ||
        verified.initialKit.sellingPlanId !== selection.initialKit.sellingPlanId ||
        selection.initialKit.quantity !== 1) return null;
    const item = { id: Number(verified.initialKit.variantId), quantity: 1 };
    if (verified.mode === 'refills') {
      item.selling_plan = Number(verified.initialKit.sellingPlanId);
      item.properties = {
        'Refill lancet size': verified.lineItemProperties['Refill lancet size'],
        'Refill frequency': verified.lineItemProperties['Refill frequency'],
        'Pip refill program': config.programKey
      };
    }
    return { items: [item] };
  }
  function pipMeterRefillCartSignature(cart) {
    if (!cart || !Array.isArray(cart.items)) return null;
    return JSON.stringify(cart.items.map(item => ({
      key: String(item.key || ''), id: String(item.variant_id ?? item.id), quantity: item.quantity,
      plan: String(item.selling_plan_allocation?.selling_plan?.id || ''),
      properties: Object.entries(item.properties || {}).sort()
    })).sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b))));
  }
  function pipMeterRefillItemMatches(item, expected) {
    if (!item || String(item.variant_id ?? item.id) !== String(expected.id) || !Number.isInteger(item.quantity) || item.quantity < 1) return false;
    const plan = item.selling_plan_allocation?.selling_plan?.id ?? item.selling_plan;
    if (String(plan || '') !== String(expected.selling_plan || '')) return false;
    return Object.entries(expected.properties || {}).every(([name, value]) => item.properties?.[name] === value);
  }
  function pipMeterRefillMatchingQuantity(cart, expected) {
    return (cart?.items || []).filter(item => pipMeterRefillItemMatches(item, expected)).reduce((total, item) => total + item.quantity, 0);
  }
  if (!customElements.get('pip-refill-preview')) {
    customElements.define('pip-refill-preview', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.cartState = null;
        this.cartError = false;
        this.submitting = false;
        this.postUncertain = false;
        this.addStatus = null;
        try { this.refillConfig = JSON.parse(this.querySelector('[data-refill-config]').textContent); } catch { this.refillConfig = null; }
        this.addEventListener('change', () => {
          if (this.submitting) return;
          if (!this.submitting && !this.postUncertain) this.addStatus = null;
          this.update();
        });
        const form = this.querySelector('[data-pip-meter-refill-form]');
        this.formId = form.getAttribute('data-pip-meter-refill-form');
        this.removeInjectedWidget();
        this.widgetObserver = new MutationObserver(() => this.removeInjectedWidget());
        this.widgetObserver.observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['id'] });
        form.addEventListener('submit', event => this.submitSelection(event), true);
        this.update();
        this.refreshCart();
        this.returnHandler = () => {
          if (!this.submitting) this.refreshCart();
        };
        window.addEventListener('pageshow', this.returnHandler);
        window.addEventListener('focus', this.returnHandler);
        this.cartChangeHandler = event => {
          if (this.submitting) return;
          const cart = event.detail?.cart?.cart;
          if (!cart || typeof cart.currency !== 'string' || !Number.isInteger(cart.item_count) || !Array.isArray(cart.items)) return;
          this.cartState = cart;
          this.cartError = false;
          if (!this.postUncertain) this.addStatus = null;
          this.update();
        };
        document.addEventListener('rebuy:cart.change', this.cartChangeHandler);
      }
      disconnectedCallback() {
        this.widgetObserver?.disconnect();
        window.removeEventListener('pageshow', this.returnHandler);
        window.removeEventListener('focus', this.returnHandler);
        document.removeEventListener('rebuy:cart.change', this.cartChangeHandler);
      }
      removeInjectedWidget() {
        const form = this.querySelector('[data-pip-meter-refill-form]');
        if (this.formId && form.getAttribute('id') !== this.formId) form.setAttribute('id', this.formId);
        form.querySelectorAll('.rc-container-wrapper').forEach(widget => widget.remove());
        form.querySelectorAll('[name="selling_plan"]:not([data-refill-field])').forEach(field => { field.disabled = true; field.remove(); });
      }
      async refreshCart() {
        const requestNumber = this.cartRequestNumber = (this.cartRequestNumber || 0) + 1;
        this.cartState = null;
        this.cartError = false;
        this.update();
        try {
          const url = this.refillConfig?.cartUrl;
          if (typeof url !== 'string' || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\.js$/i.test(url)) throw new Error('Invalid cart route');
          const response = await fetch(url, { method: 'GET', credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('Cart unavailable');
          const cart = await response.json();
          if (requestNumber !== this.cartRequestNumber) return false;
          this.cartState = cart;
        } catch {
          if (requestNumber !== this.cartRequestNumber) return false;
          this.cartError = true;
        }
        this.update();
        return !this.cartError;
      }
      async openRebuyCart(cart) {
        const smartCart = window.Rebuy?.SmartCart;
        if (typeof smartCart?.show !== 'function') throw new Error('Cart drawer unavailable');
        if (typeof smartCart.setCart === 'function') {
          await smartCart.setCart(cart);
        } else {
          const rebuyCart = window.Rebuy?.Cart;
          if (typeof rebuyCart?.fetchShopifyCart !== 'function') throw new Error('Cart refresh unavailable');
          await new Promise((resolve, reject) => {
            let settled = false;
            const finish = (error, updated) => {
              if (settled) return;
              settled = true;
              clearTimeout(timer);
              if (error || !updated || typeof updated !== 'object') reject(error || new Error('Cart refresh unavailable'));
              else resolve(updated);
            };
            const timer = setTimeout(() => finish(new Error('Cart refresh timed out')), 10000);
            try {
              const pending = rebuyCart.fetchShopifyCart(updated => finish(null, updated));
              if (pending && typeof pending.catch === 'function') pending.catch(error => finish(error));
            } catch (error) { finish(error); }
          });
        }
        await smartCart.show();
      }
      async submitSelection(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.submitting || this.postUncertain) return;
        this.addStatus = null;
        this.update();
        if (this.gate !== 'ready') return;
        const selection = this.selectionHandoff;
        const url = this.refillConfig?.cartAddUrl;
        const payload = buildPipMeterRefillCartPayload(selection, this.refillConfig);
        if (!payload || typeof url !== 'string' || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/add\.js$/i.test(url)) {
          this.addStatus = 'rejected';
          this.update();
          return;
        }
        const form = this.querySelector('[data-pip-meter-refill-form]');
        this.removeInjectedWidget();
        const radios = Array.from(form.querySelectorAll('input[type="radio"]'));
        const radioStates = radios.map(input => ({ input, disabled: input.disabled }));
        radios.forEach(input => { input.disabled = true; });
        form.querySelectorAll('input[type="hidden"][data-refill-field]').forEach(input => { input.disabled = true; });
        this.submitting = true;
        this.update();
        let beforeCart = null;
        let beforeQuantity = 0;
        let postStarted = false;
        let addConfirmed = false;
        let knownRejection = false;
        try {
          const checked = await this.refreshCart();
          if (!checked || resolvePipMeterRefillGate(selection, this.refillConfig, this.cartState) !== 'ready') return;
          beforeCart = pipMeterRefillCartSignature(this.cartState);
          beforeQuantity = pipMeterRefillMatchingQuantity(this.cartState, payload.items[0]);
          const controller = new AbortController();
          const timer = setTimeout(() => controller.abort(), 20000);
          let response;
          try {
            postStarted = true;
            response = await fetch(url, {
              method: 'POST', credentials: 'same-origin', signal: controller.signal,
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(payload)
            });
          } finally { clearTimeout(timer); }
          if (!response.ok) {
            knownRejection = [400, 404, 422].includes(response.status);
            throw new Error('Cart add rejected');
          }
          const added = await response.json();
          if (!added || !Array.isArray(added.items) || !added.items.some(item => pipMeterRefillItemMatches(item, payload.items[0]))) {
            throw new Error('Cart add response unavailable');
          }
          if (!await this.refreshCart()) throw new Error('Cart refresh unavailable');
          if (pipMeterRefillMatchingQuantity(this.cartState, payload.items[0]) !== beforeQuantity + 1) throw new Error('Cart selection could not be confirmed');
          addConfirmed = true;
          await this.openRebuyCart(this.cartState);
          this.addStatus = 'added';
        } catch {
          if (addConfirmed) {
            this.postUncertain = true;
            this.addStatus = 'drawer';
          } else if (postStarted) {
            const refreshed = await this.refreshCart();
            if (knownRejection && refreshed && beforeCart === pipMeterRefillCartSignature(this.cartState)) {
              this.addStatus = 'rejected';
            } else {
              this.postUncertain = true;
              this.addStatus = 'uncertain';
            }
          } else {
            this.addStatus = 'rejected';
          }
        } finally {
          radioStates.forEach(({ input, disabled }) => { input.disabled = disabled; });
          form.querySelectorAll('input[type="hidden"][data-refill-field]').forEach(input => { input.disabled = true; });
          this.submitting = false;
          this.update();
        }
      }
      update() {
        const selected = name => this.querySelector(`[name="${name}"]:checked`);
        const kit = selected('preview_kit');
        const mode = selected('preview_mode');
        const size = selected('preview_size');
        const frequency = selected('preview_frequency');
        const choice = { kit: kit?.value, mode: mode?.value, size: size?.value, frequency: frequency?.value };
        const handoff = resolvePipMeterRefillSelection(choice, this.refillConfig);
        this.selectionHandoff = handoff;
        this.dataset.handoff = handoff ? JSON.stringify(handoff) : '';
        this.gate = this.cartError ? 'error' : resolvePipMeterRefillGate(handoff, this.refillConfig, this.cartState);
        this.querySelector('.pip-refill-preview__button').disabled = this.gate !== 'ready' || this.submitting || this.postUncertain;
        const status = this.querySelector('[data-refill-status]');
        status.textContent = status.dataset[this.submitting ? 'submitting' : this.addStatus || this.gate] || '';
        status.hidden = !status.textContent;
        this.querySelector('[data-cart-link]').hidden = this.gate !== 'cart' && !['drawer', 'uncertain'].includes(this.addStatus);
        this.querySelector('[data-invalid]').hidden = !!handoff;
        const recurring = choice.mode === 'refills';
        this.querySelector('[data-refill-options]').hidden = !recurring;
        this.querySelectorAll('[data-recurring-row]').forEach(row => { row.hidden = !recurring || !handoff; });
        this.querySelector('[data-kit-only]').hidden = recurring;
        this.querySelectorAll('[data-kit-count]').forEach(item => { item.textContent = item.dataset[choice.kit]; });
        const money = cents => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
        this.querySelectorAll('.pip-refill-preview__kit label').forEach(option => {
          const alternative = resolvePipMeterRefillSelection({ ...choice, kit: option.querySelector('input').value }, this.refillConfig);
          const fallback = resolvePipMeterRefillSelection({ ...choice, kit: option.querySelector('input').value, mode: 'kit' }, this.refillConfig);
          option.querySelector('[data-kit-original]').hidden = !alternative || !recurring;
          if (fallback) option.querySelector('[data-kit-original]').textContent = money(fallback.previewPricing.initialRegularCents);
          option.querySelector('[data-kit-price]').textContent = alternative ? money(alternative.previewPricing.initialCents) : fallback ? money(fallback.previewPricing.initialCents) : '—';
        });
        if (!handoff) {
          this.dataset.refillVariant = '';
          this.dataset.refillSku = '';
          this.dataset.refillPlan = '';
          const fallback = resolvePipMeterRefillSelection({ ...choice, mode: 'kit' }, this.refillConfig);
          if (fallback) {
            const fallbackPrice = money(fallback.previewPricing.initialCents);
            this.querySelector('[data-price]').textContent = fallbackPrice;
            const summary = this.closest('.product-info-inner') || this.closest('sticky-sidebar') || this.parentElement;
            const summaryPrice = summary?.querySelector('.pip-product-price__value');
            if (summaryPrice) summaryPrice.textContent = fallbackPrice;
            const summaryLabel = summary?.querySelector('.pip-product-price small');
            if (summaryLabel) summaryLabel.textContent = this.refillConfig.texts?.oneTimePrice || '';
          }
          return;
        }
        const price = money(handoff.previewPricing.initialCents);
        this.querySelector('[data-original-price]').textContent = money(handoff.previewPricing.initialRegularCents);
        this.querySelector('[data-price]').textContent = price;
        const label = input => input?.nextElementSibling.firstChild.textContent.trim() || '';
        this.querySelector('[data-size-summary]').textContent = label(size);
        this.querySelector('[data-frequency-summary]').textContent = label(frequency);
        if (recurring) {
          this.querySelector('[data-refill-original]').textContent = money(handoff.previewPricing.refillRegularCents);
          this.querySelector('[data-refill-price]').textContent = money(handoff.previewPricing.refillCents);
        }
        const summary = this.closest('.product-info-inner') || this.closest('sticky-sidebar') || this.parentElement;
        const summaryPrice = summary?.querySelector('.pip-product-price__value');
        if (summaryPrice) summaryPrice.textContent = price;
        const summaryLabel = summary?.querySelector('.pip-product-price small');
        if (summaryLabel) summaryLabel.textContent = this.refillConfig.texts?.[recurring ? 'subscriptionPrice' : 'oneTimePrice'] || '';
        this.dataset.refillVariant = handoff.futureRefill?.variantId || '';
        this.dataset.refillSku = handoff.futureRefill?.sku || '';
        this.dataset.refillPlan = handoff.futureRefill?.sellingPlanId || '';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
